import { Action } from '@ngrx/store';

export enum GlobalDocumentsActions {
  GetAllGlobalDocuments = '[GlobalDocuments] Get All Global Documents',
  GetAllGlobalDocumentsSuccess = '[GlobalDocuments] Get All Global Documents Success',
  GetAllGlobalDocumentsError = '[GlobalDocuments] Get All Global Documents Error',
  CloneToCompany = '[GlobalDocuments] Clone To Company',
  CloneToCompanySuccess = '[GlobalDocuments] Clone To Company Success',
  CloneToCompanyError = '[GlobalDocuments] Clone To Company Error',
  ResetCloneToCompanyStatus = '[GlobalDocuments] Reset Clone To Company Status',
  AddGlobalDocument = '[GlobalDocuments] Add Global Document',
  AddGlobalDocumentSuccess = '[GlobalDocuments] Add Global Document Success',
  AddGlobalDocumentError = '[GlobalDocuments] Add Global Document Error',
  ResetAddGlobalDocumentStatus = '[GlobalDocuments] Reset Add Global Document Status',
  GetGlobalDocumentTypes = '[GlobalDocuments] Get Document Types',
  GetGlobalDocumentTypesSuccess = '[GlobalDocuments] Get Document Types Success',
  GetGlobalDocumentTypesError = '[GlobalDocuments] Get Document Types Error',
  EditGlobalDocument = '[GlobalDocuments] Edit Global Document',
  EditGlobalDocumentSuccess = '[GlobalDocuments] Edit Global Document Success',
  EditGlobalDocumentError = '[GlobalDocuments] Edit Global Document Error',
  ResetEditGlobalDocumentStatus = '[GlobalDocuments] Reset Edit Global Document Status',
  DeleteGlobalDocument = '[GlobalDocuments] Delete Global Document',
  DeleteGlobalDocumentSuccess = '[GlobalDocuments] Delete Global Document Success',
  DeleteGlobalDocumentError = '[GlobalDocuments] Delete Global Document Error',
  ResetDeleteGlobalDocumentStatus = '[GlobalDocuments] Reset Delete Global Document Status',
}

export class GetAllGlobalDocuments implements Action {
  public readonly type = GlobalDocumentsActions.GetAllGlobalDocuments;
}

export class GetAllGlobalDocumentsSuccess implements Action {
  public readonly type = GlobalDocumentsActions.GetAllGlobalDocumentsSuccess;
  constructor(public payload: any) {}
}

export class GetAllGlobalDocumentsError implements Action {
  public readonly type = GlobalDocumentsActions.GetAllGlobalDocumentsError;
  constructor(public payload: any) {}
}

export class CloneToCompany implements Action {
  public readonly type = GlobalDocumentsActions.CloneToCompany;
  constructor(public payload: { global_doc_ids: number[]; company_id: number }) {}
}

export class CloneToCompanySuccess implements Action {
  public readonly type = GlobalDocumentsActions.CloneToCompanySuccess;
  constructor(public payload: any) {}
}

export class CloneToCompanyError implements Action {
  public readonly type = GlobalDocumentsActions.CloneToCompanyError;
  constructor(public payload: any) {}
}

export class ResetCloneToCompanyStatus implements Action {
  public readonly type = GlobalDocumentsActions.ResetCloneToCompanyStatus;
}

export class AddGlobalDocument implements Action {
  public readonly type = GlobalDocumentsActions.AddGlobalDocument;
  constructor(public payload: { title: string; doc_type_id: number; editorContent: string }) {}
}

export class AddGlobalDocumentSuccess implements Action {
  public readonly type = GlobalDocumentsActions.AddGlobalDocumentSuccess;
  constructor(public payload: any) {}
}

export class AddGlobalDocumentError implements Action {
  public readonly type = GlobalDocumentsActions.AddGlobalDocumentError;
  constructor(public payload: any) {}
}

export class ResetAddGlobalDocumentStatus implements Action {
  public readonly type = GlobalDocumentsActions.ResetAddGlobalDocumentStatus;
}

export class GetGlobalDocumentTypes implements Action {
  public readonly type = GlobalDocumentsActions.GetGlobalDocumentTypes;
}

export class GetGlobalDocumentTypesSuccess implements Action {
  public readonly type = GlobalDocumentsActions.GetGlobalDocumentTypesSuccess;
  constructor(public payload: any) {}
}

export class GetGlobalDocumentTypesError implements Action {
  public readonly type = GlobalDocumentsActions.GetGlobalDocumentTypesError;
  constructor(public payload: any) {}
}

export class EditGlobalDocument implements Action {
  public readonly type = GlobalDocumentsActions.EditGlobalDocument;
  constructor(public payload: { id: number; title: string; doc_type_id: number; editorContent: string }) {}
}

export class EditGlobalDocumentSuccess implements Action {
  public readonly type = GlobalDocumentsActions.EditGlobalDocumentSuccess;
  constructor(public payload: any) {}
}

export class EditGlobalDocumentError implements Action {
  public readonly type = GlobalDocumentsActions.EditGlobalDocumentError;
  constructor(public payload: any) {}
}

export class ResetEditGlobalDocumentStatus implements Action {
  public readonly type = GlobalDocumentsActions.ResetEditGlobalDocumentStatus;
}

export class DeleteGlobalDocument implements Action {
  public readonly type = GlobalDocumentsActions.DeleteGlobalDocument;
  constructor(public payload: { id: number }) {}
}

export class DeleteGlobalDocumentSuccess implements Action {
  public readonly type = GlobalDocumentsActions.DeleteGlobalDocumentSuccess;
  constructor(public payload: any) {}
}

export class DeleteGlobalDocumentError implements Action {
  public readonly type = GlobalDocumentsActions.DeleteGlobalDocumentError;
  constructor(public payload: any) {}
}

export class ResetDeleteGlobalDocumentStatus implements Action {
  public readonly type = GlobalDocumentsActions.ResetDeleteGlobalDocumentStatus;
}

export type GlobalDocumentsAction =
  | GetAllGlobalDocuments
  | GetAllGlobalDocumentsSuccess
  | GetAllGlobalDocumentsError
  | CloneToCompany
  | CloneToCompanySuccess
  | CloneToCompanyError
  | ResetCloneToCompanyStatus
  | AddGlobalDocument
  | AddGlobalDocumentSuccess
  | AddGlobalDocumentError
  | ResetAddGlobalDocumentStatus
  | GetGlobalDocumentTypes
  | GetGlobalDocumentTypesSuccess
  | GetGlobalDocumentTypesError
  | EditGlobalDocument
  | EditGlobalDocumentSuccess
  | EditGlobalDocumentError
  | ResetEditGlobalDocumentStatus
  | DeleteGlobalDocument
  | DeleteGlobalDocumentSuccess
  | DeleteGlobalDocumentError
  | ResetDeleteGlobalDocumentStatus;
